/**
 * Machina Version
 *
 * Single source of truth for app version.
 * Update this one file for all version displays.
 */
export const MACHINA_VERSION = '0.0.13';
//# sourceMappingURL=version.js.map